/*--------------------------------------
    API ROUTE MAP
--------------------------------------*/

import $ from 'jquery';
import _ from "lodash";

const apiRoute = {
    requestList: '/api/requests/list',
    unitedRequest: (login) => `/api/unitedRequest/login/${login}`,
    userList: '/api/user/list',
    userListDownloadXLS: structure => `/api/users/xlsx?${encodeURI($.param({ structure: JSON.stringify(structure) }))}`,
    activePersonList: '/api/users/persons',
    personPhoneList: userId => `/api/user/${userId}/phones`,
    createPersonsPhones: userId => `/api/user/${userId}/createPersonsPhones`,
    createRequest: '/api/requests',
    createRequestFromExplanatoryNote: `/api/requests/createFromExplanatoryNote`,
    requestListDownloadXLS: structure => `/api/requests/xlsx?${encodeURI($.param({ structure: JSON.stringify(structure) }))}`,
    orgRequestListDownloadXLS: (structure, orgId) => `/api/userorganizations/${orgId}/requests/xlsx?${encodeURI($.param({structure: JSON.stringify(structure)}))}`,
    createByCopy: (copyRequestId, copyType) => `/api/requests/createByCopy?copyRequestId=${copyRequestId}&copyType=${copyType}`,
    searchConclusion: (typeNumber, number, project, notecpe) => {
      let endpoint = `/api/conclusions/search?type=${typeNumber}&number=${number}`;
      if (notecpe) {
        if (project) { endpoint += `&project=${project}`; }
        endpoint += '&notecpe=true';
      } else {
        if (project) { endpoint += `&project=${project}`; }
      }
      return endpoint;
    },
    createUser: '/api/users',
    request: (id) => '/api/request/' + id,
    zipDocsReady: (id) => '/api/request/zipDocsReady/' + id,
    missingDocuments: (requestId) => `/api/request/${requestId}/missingDocuments`,
    genarateCompleteness: (id) => `/api/request/${id}/generateCompletenessItems`,
    fileRepoAPI: (requestId) => `/api/${requestId}/filerepo`,
    infoOfUseProjectDocs: (requestId) => `/api/request/${requestId}/infoOfUseProjectDocs`,
    requestSignReport: (requestId) => `/api/request/${requestId}/signReport`,
    requestDownloadDocs: (requestId, type = null, param = null) => {
      let query = `/api/request/${requestId}/downloadDocs`;
      if (type) {
        query += `?docs=${type}` + (param ? `&${param}=true` : '');
      } else if (param) {
        query += `?${param}=true`;
      }
      return query;
    },
    allRemarksAnswered: (requestId) => `/api/request/${requestId}/allRemarksAnswered`,
    linkedRequest: (requestId, goal) => `/api/request/${requestId}/linked/${goal}`,
    createLinkedRequest: (requestId, goal) => `/api/requests/createLinkedRequest/${requestId}` + (goal ? `?goal=${goal}` : ""),
    linkRequests: (requestId1, requestId2) => `/api/requests/link/${requestId1}` + (requestId2 ? `?linkedRequestId=${requestId2}` : ""),
    checkLenkedRequest: (requestId) => `/api/linkedrequest/check/${requestId}`,
    createFinancing: (requestId) => `/api/financing/${requestId}`,
    removeFinancing: (id) => `/api/financing/${id}`,
    checkFormationDeadlineExtending: (requestId) => `/api/formationdeadlineextending/check/${requestId}`,
    planStages: (requestId, typeList = "default") => `/api/request/${requestId}/plan-stages?typeList=${typeList}`,
    stagesHistory: (requestId) => `/api/request/${requestId}/history`,
    updateSignatureVerificationExclusion: (requestId, signatureVerificationExclusion) => `/api/request/${requestId}/signatureVerification?signatureVerificationExclusion=${signatureVerificationExclusion}`,
    updateVerificationExclusions: (
        requestId,
        signatureVerificationExclusion,
        deadlineVerificationExclusion,
        noprizVerificationExclusion,
        deadlineVerificationExclusionEsPreExamination,
        signersVerificationExclusion
    ) =>
      `/api/request/${requestId}/updateVerificationExclusions?signatureVerificationExclusion=${signatureVerificationExclusion}&deadlineVerificationExclusion=${deadlineVerificationExclusion}&noprizVerificationExclusion=${noprizVerificationExclusion}&deadlineVerificationExclusionEsPreExamination=${deadlineVerificationExclusionEsPreExamination}&signersVerificationExclusion=${signersVerificationExclusion}`,
    notValidSignaturesReport: (requestId) => `/api/request/${requestId}/notValidSignaturesReport`,
    
    
    versionServiceXml: '/api/versionServiceXml',
    versionExplanatoryNote: '/api/versionExplanatoryNote',
    journal: '/api/journal',
    version: '/api/version',
    journalDownloadXLS: structure => `/api/journal/xlsx?${encodeURI($.param({structure: JSON.stringify(structure)}))}`,

    addPart: (objectId, index) => `/api/objects/${objectId}/parts/${index}`,
    removePart: partId => `/api/parts/${partId}`,

    createParticipant: (requestId) => `/api/participants/${requestId}`,
    listParticipant: (requestId) => `/api/participants/${requestId}`,
    listParticipantText: (requestId) => `/api/participants/${requestId}/text`,
    participant: (id) => '/api/participant/' + id,
    deleteParticipant: (id) => '/api/participant/' + id,
    decline: (fullName) => '/api/decline/' + fullName,
    participantsListGranted: (requestId) => `/api/participant_request/${requestId}/listGranted`,

    createBankAccountPersonal: (participantId, bankAccountId) => `/api/participants/${participantId}/bank/${bankAccountId}/personalAccount`,
    deleteBankAccountPersonal: (participantId, id) => `/api/participants/${participantId}/bank/personalAccount/${id}`,

    createActionBasis: (participantId, contactId) => `/api/participants/${participantId}/${contactId}/bases`,
    deleteActionBasis: (participantId, id) => `/api/participants/${participantId}/bases/${id}`,

    addSteadInfo: (requestId, infoType) => `/api/request/${requestId}/steadInfoType/${infoType}`,
    removeSteadInfo: (requestId, steadInfoId) => `/api/request/${requestId}/steadInfo/${steadInfoId}`,
    searchOrganizationInfoByInn: inn =>`/api/organizations/getOrgInn/${inn}`,
    searchOrganizationInfoByOrgn: ogrn =>`/api/organizations/getOrgOgrn/${ogrn}`,
    searchIndividualProprietorInfoByInn: ogrnIp =>`/api/organizations/getEntInn/${ogrnIp}`,
    searchIndividualProprietorInfoByOgrn: ogrnIp =>`/api/organizations/getEntOgrn/${ogrnIp}`,
    searchOrganization: '/api/organization/search',
    searchBank: (bik) => '/api/banks/search/' + bik,
    indicatorsTEP: '/api/techindicators',
    fullIndicatorsTEP: '/api/fulltechindicators',
    indicatorsMainTEP: '/api/techindicatorsMain',
    objectPurpose: '/api/objectPurpose',
    objectMainPurpose: '/api/objectMainPurpose',
    kosfn: '/api/kosfn',
    catalogMDM: (code, strQuery) => `/api/catalog/${code}${strQuery ? '?' + strQuery : '' }`,

    permissions: {
        examinationRequest: (objectId) => `/api/permissions/request/${ objectId }`,
    },
    requestRoles: (id) => `/api/roles/request/${id}`,

    login: "/api/login",
    loginEsia: "/api/esia/login",
    loginAisEsia: "/api/ais-esia/login",
    logout: "/api/logout",
    user: (id) => `/api/user/${ id }`,

    fileUpload: '/api/file',
    signedFileUpload: (isDetachedSign) => {
      let str = '/api/signedFile';
      if (!!isDetachedSign) {
        str += '?isDetachedSign=true';
      }
      return str;
    },
    signedFileAndFolderUpload: (folderCode, forPZ, isDetachedSign) => {
      let url = `/api/signedFile?folderCode=${folderCode}`;
      if (forPZ && forPZ.isFromExplanatoryNoteRequest) {
        url += `&requestId=${forPZ.requestId}&isNote=true`;
      }
      if (!!isDetachedSign) {
        url += '&isDetachedSign=true';
      }
      return url;
    },
    signedFileUploadWithoutVerification :(folderCode) => `/api/signedFile?withoutVerification=true&folderCode=${ folderCode }`,
    // signedPDFileAndGgeFolderUpload:(folderId, removeGgeFormatRestriction) => !_.isUndefined(removeGgeFormatRestriction) && !_.isNull(removeGgeFormatRestriction) ?
    //     `/api/signedPDFile?completenessFolderId=${folderId}&removeGgeFormatRestriction=${removeGgeFormatRestriction}` :
    //     `/api/signedPDFile?completenessFolderId=${folderId}&withoutVerification=true`,
    signedPDFileAndGgeFolderUpload: (folderId, removeGgeFormatRestriction, forPZ, isDetachedSign) => {
      let strAdd = '';
      if (forPZ && forPZ.isFromExplanatoryNoteRequest) {
        strAdd += `&requestId=${forPZ.requestId}&isNote=true`;
      }
      if (!!isDetachedSign) {
        strAdd += '&isDetachedSign=true';
      }
      return !_.isUndefined(removeGgeFormatRestriction) && !_.isNull(removeGgeFormatRestriction) ?
        `/api/signedPDFile?completenessFolderId=${folderId}&removeGgeFormatRestriction=${removeGgeFormatRestriction}${strAdd}` :
        `/api/signedPDFile?completenessFolderId=${folderId}&withoutVerification=true`;  
    },
    fileDownloadLink: (fileModel) => `/api/file/download/${ fileModel.id }`,
    fileDownloadPdfLink: (fileModel) => `/api/file/downloadPdf/${ fileModel.id }`,
    fileDownloadByRef: (fileRef) => `/api/file/download/${ fileRef }`,
    fileDownloadBase64ByRef: (fileRef) => `/api/file/download/${ fileRef }/base64`,
    fileInfo: (fileRef,uploadFieldCode,folderId) =>
        `/api/file/info/${fileRef}?${!_.isUndefined(uploadFieldCode) ? `requestSlotCode=${uploadFieldCode}` : ''}${!_.isUndefined(folderId) ? `&completenessFolderId=${folderId}` : ''}`
    ,
    fileInfoWithWorkType: (fileRef,workTypeRef= 0,examTypeRef= 0,folderId) =>
        `/api/file/info/${fileRef}/${workTypeRef}/${examTypeRef}?${!_.isUndefined(folderId) ? `completenessFolderId=${folderId}` : ''}`,
    fileRemove: (fileRef, forPZ) => {
      let url = `/api/file/delete/${fileRef}`;
      if (forPZ && forPZ.isFromExplanatoryNoteRequest) {
        url += `?requestId=${forPZ.requestId}&isNote=true`;
      }
      return url;
    },
    fileDigest: (fileRef, keyAlg) => `/api/file/digest/${fileRef}/${keyAlg}`,
    fileSignSave: (fileRef, withoutVerification, forPZ, requestId, isNote = false) => {
        let url = `/api/file/sign/${fileRef}?withoutVerification=${!!withoutVerification}`;
        if (forPZ && forPZ.isFromExplanatoryNoteRequest) {
          url += `&requestId=${forPZ.requestId}&isNote=true`;
        } else {
          url += `&requestId=${requestId}`;
          if (isNote) {
            url += `&isNote=true`;
          }
        }
        return url;
    },
    fileSignInfo: (fileRef) => `/api/file/verifySign/${fileRef}`,
    checkUploadSignature: (fileRef, signFileRef) => `/api/file/${fileRef}/signature/${signFileRef}`,
    deleteSign: (fileRef) => `/api/file/sign/${fileRef}`,

    createDocument: (docType) => `/api/documents/${ docType }`,
    listDocument: (docType, ownerId) => '/api/documents/' + docType + (ownerId && '?ownerId=' + ownerId || ''),
    document: (docType, id) => `/api/document/${ docType }/${ id }`,
    correspondence: (ownerId) => `/api/correspondence/${ ownerId }`,
    allCorrespondence: (ownerId) => `/api/allcorrespondence/${ ownerId }`,
    letter: (id) => `/api/letter${ id ? '/' + id : "" }`,
    sendLetter: (id) => `/api/sendletter/${ id }`,

    listDocumentByOwner: (docType, ownerId) => `/api/documents/${ docType }/${ ownerId }`,
    listDocumentsByTypesAndOwner: (docTypes, ownerId) => `/api/documents/by-types/${ ownerId }?docTypes=${docTypes.join('&docTypes=')}`,
    deleteDocument: (docType, ownerId) => `/api/documents/${ docType }/${ ownerId }`,
    documentByOwner: (docType, ownerId) => `/api/documents/${ docType }/${ ownerId }`,
    saveExplanatoryNote: (explanatoryNoteFileRef) => `/api/document/explanatoryNote/${explanatoryNoteFileRef}`,
    deleteExplanatoryNote: (explanatoryNoteDocumentsId) => `/api/document/explanatoryNote/${explanatoryNoteDocumentsId}`,
    saveExplanatoryNoteArchive: (explanatoryNoteDocumentsId,explanatoryNoteArchiveId) => _.isNull(explanatoryNoteArchiveId) ?
        `/api/document/explanatoryNoteArchive/${explanatoryNoteDocumentsId}` :
        `/api/document/explanatoryNoteArchive/${explanatoryNoteDocumentsId}?archiveId=${explanatoryNoteArchiveId}`,
    saveCertificatesOfAdmissions: '/api/documents/certificateOfAdmission/saveList',
    printedDocuments: (requestId) => `/api/${ requestId }/printforms`,
    requestInventoryForm: (requestId) => `/api/${ requestId }/requestInventoryForm`,
    sendAdditionalAgreement: (requestId, documentId) => `/api/requests/${ requestId }/documents/${documentId}`,

    localRemarksDashboard: requestId => `/api/request/${requestId}/localRemarksDashboard`,
    isNewRemarksMethod: (requestId) => `/api/request/${requestId}/isNewRemarksMethod`,

    checkRemarksAnswers: (requestId) => `/api/request/${requestId}/checkRemarksAnswers`,

    userorganizations: '/api/userorganizations',
    organizationRequestList: (organizationId) => `/api/userorganizations/${organizationId}/requests`,

    isPdOpeningStartAllowed: (requestId) => `/api/pdOpening/${requestId}/isRequestStageAllowed`,
    pdOpeningCurrentStage: (requestId) => `/api/pdOpening/${ requestId }/currentStage`,
    createPdOpeningRequest: (requestId) => `/api/pdOpening/${ requestId }/createRequest`,
    saveSelectedPdForOpening: (requestId) => `/api/pdOpening/${ requestId }/saveSelected`,
    saveEditedPd: (requestId) => `/api/pdOpening/${ requestId }/saveEdited`,
    abortRequest: (requestId) => `/api/pdOpening/${ requestId }/abortRequest`,

    completenessTree: (requestId) => `/api/request/${ requestId }/folders`,
    slots: (folderId) => `/api/folders/${ folderId }/items`,
    slotFiles: (folderId) => `/api/folders/${ folderId }/files`,
    swapSlot: (item1, item2) => `/api/completenessitems/${ item1 }/swap/${ item2 }`,

    stageInfo: (stageRef, requestId) => '/api/stages/request/' + stageRef + '/' + requestId,
    stageUpdate: (requestId, stageRef, goNext) => '/api/stages/' + requestId + '/' + stageRef + (!!goNext ? '?next=true' : ''),

    stagesGroup: (userId) => `/api/stagesgroup`,
    stagesGroupOrganization: organizationId => `/api/userorganizations/${organizationId}/stagesgroup`,
    organizationsCheck: '/api/userorganizations/check',

    addSlot: (folderId) => '/api/folders/' + folderId + '/item',
    removeSlot: (itemId, forPZ) => {
      let url = '/api/completenessitems/' + itemId;
      if (forPZ && forPZ.isFromExplanatoryNoteRequest) {
        url += `?requestId=${forPZ.requestId}&isNote=true`;
      }
      return url;
    },
    restoreSlot: (itemId) => '/api/completenessitems/' + itemId + '/restore',
    slotIgnored: folderId => '/api/folders/' + folderId + '/ignored',
    slotRemoveGgeFormatRestriction: folderId => '/api/folders/' + folderId + '/removeGgeFormatRestriction',
    slotUploadFile: (itemId, forPZ) => {
      let url = `/api/completenessitems/${itemId}/upload`;
      if (forPZ && forPZ.isFromExplanatoryNoteRequest) {
        url += `?requestId=${forPZ.requestId}&isNote=true`;
      }
      return url;
    },
    fileVersion: (ownerId) => '/api/file/' + ownerId + '/lastVersion',
    fileVersionList: (ownerId) => '/api/file/' + ownerId + '/versions',

    listNotSignedAll: (requestId) => `/api/completenessitems/listnotsigned/${requestId}`,

    checkEmail: '/api/checkEmail',

    fiasAddress: (guid) => `/api/fias/address/${ guid }`,
    fiasBuilding: (guid) => `/api/fias/house/${ guid }`,
    fiasNumberOfGroundArea: (guid) => `/api/fias/stead/${ guid }`,
    fiasFlat: (guid) => `/api/fias/room/${ guid }`,
    listFias: (type, guid) => `/api/fias/${ type }/${ guid || ''}`,
    searchFias: (type) => `/api/fias/search/${ type }`,
    choiceExaminationPlacement: '/api/examinationplacement',
    declarantContacts: requestId => `/api/request/${requestId}/declarantcontacts`,
    declarantContactsSend: requestId => `/api/request/${requestId}/declarantcontacts/send`,

    notification: '/api/notifications',
    notificationCount: '/api/notificationsCount',

    systemEventList: 'api/events',
    newSystemEvent: 'api/event',
    deleteSystemEvent: id => `api/event/${id}`,

    qualityAssessmentList: '/api/qa',
    qualityAssessment: (id) => `/api/qaform/${id}`,
    newQualityAssessment: '/api/qaform/new',
    qualityAssessmentDownloadXLS: structure => `/api/qa/xlsx?${encodeURI($.param({structure: JSON.stringify(structure)}))}`,

    // Landings route
    landingView: "/api/landing/view",

    landingListCommonInfo: "/api/landing/commonInfo",
    landingListDocuments: "/api/landing/documents",
    landingListFAQs: "/api/landing/faqs",
    landingListInstructions: "/api/landing/instructions",
    landingListSeminars: "/api/landing/seminars",
    landingListVideo: "/api/landing/video",

    landingAddCommonInfoItem: "/api/landing/commonInfo/add",
    landingUpdateCommonInfoItem: "/api/landing/commonInfo/update",
    landingRemoveCommonInfoItem: (id) => '/api/landing/commonInfo/remove/' + id,
    landingRestoreCommonInfoItem: (id) => '/api/landing/commonInfo/restore/' + id,
    landingCommonTitle: "/api/landing/commonInfo/title",

    landingLocalSupportContacts: (examinationPlacementCode) => '/api/landing/localSupportInfo/' + examinationPlacementCode,
    landingLocalSupportUsage: (examinationPlacementCode) => '/api/landing/localSupportUsage/' + examinationPlacementCode,
    landingLocalSupportExclude: (examinationPlacementCode) => '/api/landing/localSupportExclude' + (examinationPlacementCode ? `/${examinationPlacementCode}` : ''),
    requestPlacementCode: (requestId) => !_.isUndefined(requestId) && !_.isNull(requestId) ? `/api/requestPlacementCode?requestId=${requestId}` : `/api/requestPlacementCode`,

    landingAddDocument: "/api/landing/documents/add",
    landingUpdateDocument: "/api/landing/documents/update",
    landingRemoveDocument: (id) => '/api/landing/documents/remove/' + id,
    landingRestoreDocument: (id) => '/api/landing/documents/restore/' + id,

    landingAddFAQ: "/api/landing/faqs/add",
    landingUpdateFAQ: "/api/landing/faqs/update",
    landingRemoveFAQ: (id) => '/api/landing/faqs/remove/' + id,
    landingRestoreFAQ: (id) => '/api/landing/faqs/restore/' + id,
    landingFaqAsqLink: "/api/landing/faqs/asqLink",
    landingFaqFindLink: "/api/landing/faqs/findLink",
    landingFaqAllLink: "/api/landing/faqs/allLink",

    landingSeminarPeriod: "/api/landing/seminars/period",
    landingSeminarTitle: "/api/landing/seminars/title",
    landingSeminarDescription: "/api/landing/seminars/description",
    landingSeminarDays: '/api/landing/seminars/days',
    landingSeminarSignUpLink: "/api/landing/seminars/signUpLink",
    landingSeminarAllLink: "/api/landing/seminars/allLink",

    landingAddVideo: "/api/landing/video/add",
    landingUpdateVideo: "/api/landing/video/update",
    landingRemoveVideo: (id) => '/api/landing/video/remove/' + id,
    landingRestoreVideo: (id) => '/api/landing/video/restore/' + id,

    landingAddInstruction: "/api/landing/instructions/add",
    landingUpdateInstruction: "/api/landing/instructions/update",
    landingRemoveInstruction: (id) => '/api/landing/instructions/remove/' + id,
    landingRestoreInstruction: (id) => '/api/landing/instructions/restore/' + id,
    expertSupport: {
        createComplianceEstimation: (requestId) =>
            `/api/expertSupport/request/${requestId}/createComplianceEstimation`,

        createConclusionRequest: (requestId) =>
            `/api/expertSupport/request/${requestId}/createConclusionRequest`,

        createConclusionRequestCostChanged: (requestId) =>
            `/api/expertSupport/request/${requestId}/createConclusionRequestCostChanged`,
        
        getComplianceEstimationRequestIds: (requestId) =>
            `/api/expertSupport/request/${requestId}/getComplianceEstimationRequestIds`,

        getConclusionRequestIds: (requestId) =>
            `/api/expertSupport/request/${requestId}/getConclusionRequestsIds`,

        conclusionRequestDocuments: (requestId) =>
            `/api/expertSupport/request/${requestId}/conclusionRequestDocuments`,

        requestCreatingValidationInfo: (requestId) =>
            `/api/expertSupport/request/${requestId}/requestCreatingValidationInfo`,

        lastRequestFromGroupES: requestId => `/api/expertSupport/request/${requestId}/lastRequestFromGroupES`,

        listMotivatedRejections: requestId => `/api/expertSupport/request/${requestId}/listMotivatedRejections`,

        getComplianceEstimation4ConclusionRequest: (requestId) =>
            `/api/expertSupport/request/${requestId}/getComplianceEstimation4ConclusionRequest`,

        getSelectedComplianceEstimationIds4ConclusionRequest: (requestId) =>
            `/api/expertSupport/request/${requestId}/getSelectedComplianceEstimationIds4ConclusionRequest`,

        linkComplianceEstimationsToConclusionRequest: (requestId) =>
            `/api/expertSupport/request/${requestId}/linkComplianceEstimationsToConclusionRequest`,

        terminateApplicationFormation: (requestId) =>
            `/api/expertSupport/request/${requestId}/terminateApplicationFormation`,

        linkedExpertSupportRequestId: requestId => `/api/expertSupport/request/${requestId}/expertSupportRequestId`,

        infoOfEstimatedCostChanged: requestId => `/api/expertSupport/request/${requestId}/infoOfEstimatedCostChanged`,

        changedSlotsCount: requestId => `/api/expertSupport/request/${requestId}/changedSlotsCount`,

        rootESRequestPrintforms: requestId => `/api/expertSupport/request/${requestId}/rootESRequestPrintforms`,

        getMainProjectNumber: requestId => `/api/expertSupport/request/${requestId}/expertSupportRequestId`,

        getLead: requestId => `/api/requests/${requestId}/getLead`,
    },
    checklists: {
        userRequests: () => '/api/checklists/userRequests',
        nextChecklistNumber: () => '/api/checklists/nextNumber',
        detailsByRequest: (requestId) => `/api/checklists/detailsByRequest/${requestId}`,
        infoByRequest: (requestId) => `/api/checklists/infoByRequest/${requestId}`,
        list: () => '/api/checklists/list',
        deleteChecklist: (checklistId) => `/api/checklists/${checklistId}`,
        getQuestionsByDetails: () => '/api/checklists/questionsByDetails',
        createChecklist: () => '/api/checklists/create',
        editChecklist: (checklistId) => `/api/checklists/${checklistId}`,
        getChecklist: (checklistId) => `/api/checklists/${checklistId}`,

        activateConstructor: (constructorId) => `/api/checklists/constructor/activate/${constructorId}`,
        constructorList: () => '/api/checklists/constructor/list',
        nextConstructorVersion: () => '/api/checklists/constructor/nextVersion',
        parameterGroupsCatalog: () => '/api/checklists/constructor/parameterGroupsCatalog',
        createConstructor: () => '/api/checklists/constructor',
        getConstructor: (constructorId) => `/api/checklists/constructor/${constructorId}`
    },

    userIsConfirmed:(userId) => `/api/user/${userId}/isConfirmed`,

    uploadMraFile: (requestId) => `/api/mra2/attorney/${requestId}`,
    mraList: (requestId, isHideInactiveMra) => `/api/mra2/attorneys/${requestId}?isHideInactiveMra=${isHideInactiveMra}`,
    orgMraList: (requestId, isHideInactiveMra) => `/api/mra2/attorneys-employee-eo/${requestId}?isHideInactiveMra=${isHideInactiveMra}`,
    powerParticipantList: (requestId, isHideInactiveMra) => `/api/mra2/power-participant/${requestId}?isHideInactiveMra=${isHideInactiveMra}`,
    viewMraFile: (mraId) => `/api/mra2/attorney/${mraId}/mra`,
    uploadMraSignature: (mraId) => `/api/mra2/attorney/uploadSignature/${mraId}`,
    deleteMraFile: (mraId) => `/api/mra2/attorney/${mraId}`,
    setMraRequired: (requestId, powerId, isRequired) => `/api/mra2/power-participant/${requestId}/${powerId}/set-required?required=${isRequired}`,
    mraGetSignatureData: (fileId, attorneyId) => `/api/mra2/attorneys/${attorneyId}/getSignatureData/${fileId}`,

    getExaminationCalendarData: (requestId) => `/api/request/${requestId}/calendar`,
    findRequestByProjectNumber: (projectNumber) => `/api/requests/findByProjectNumber?projectNumber=${projectNumber}`,
    getWeekendsAndHolidays: (dateFrom, dateTo) => `/api/utils/calendar?dateFrom=${dateFrom}&dateTo=${dateTo}&dayType=3`,
    getRemarksStatistic: (requestId) => `/api/request/${requestId}/remarksStatistic`,

    pspRedirect: ({requestId, requestUrl, tags = []}) =>
        `/api/psp?${requestId ? `requestId=${requestId}&url=${requestUrl}` : `url=${requestUrl}`}${tags.length && `&tags=${tags}`}`,
    getNoprizStatuses: () => `/api/nopriz/statuses`,
    localRemarkHistory: remarkId => `/api/localRemark/${remarkId}/history`,
    deleteReplyLocalRemark: remarkId => `/api/localRemark/${remarkId}/deleteReply`,
    getMessageList: chatId => `/api/chat/${chatId}/getMessageList/portal`,
    sendMessage: chatId => `/api/chat/${chatId}/sendMessage/portal`,
    readMessages: chatId => `/api/chat/${chatId}/readMessages/portal`,

    getExamTypeByOrganization: (organizationCode, note) => `/api/subdivision/${organizationCode}/examTypesByCode?${note ? 'note=true' : ''}`,

    uploadXsdSchema: () => 'api/designTask/xsdSchema/uploadXsd',
    uploadXsl: () => 'api/designTask/xsdSchema/uploadXsl',
    addXsd: () => '/api/designTask/xsdSchema/submitAdd',
    updateXsd: () => '/api/designTask/xsdSchema/submitUpdate',
    xmlVersionsList: () => '/api/designTask/xsdSchema/list',
    designTaskVersionList: (designTaskId, query) => `/api/designTask/${designTaskId}/allVersion${query || ''}`,
    copyDesignTask: (designTaskVersionId) => `/api/designTask/copy/${designTaskVersionId}`,
    createDesignTaskVersion: (designTaskVersionId) => `/api/designTask/create/${designTaskVersionId}`,
    changeDesignTaskStatus: (version, status) => `/api/designTask/changeStatus/${version}/${status}`,
    designTaskVersion: (versionId) => `/api/designTask/version/${versionId}`,
    designTaskVersions: (designTaskId) => `/api/designTask/${designTaskId}/listVersions`,
    designTaskView: (designTaskVersionId) => `/api/designTask/view/${designTaskVersionId}`,
    designTaskRoles: (designTaskId) => `/api/designTask/${designTaskId}/roles`,
    tasksCountByStatus: () => `/api/designTask/countByStatus`,
    designTaskList: '/api/designTask/listOfDesignTasks',
    designTaskSingle: (designTaskVersionId) => `/api/designTask/version/${designTaskVersionId}`,
    editDesignTaskSingle: (designTaskVersionId) => `/api/designTask/version/${designTaskVersionId}/editInfo`,
    designTasksDownloadXls: structure => `/api/designTask/xlsx?${encodeURI($.param({ structure: JSON.stringify(structure) }))}`,
    designTasksPermissions: designTaskVersionId => `/api/designTask/listPermissions/${designTaskVersionId}`,
    getDesignTaskStructure: designTaskVersionId => `/api/designTask/version/${designTaskVersionId}/getStructure`,
    editDesignTaskField: designTaskVersionId => `/api/designTask/version/${designTaskVersionId}/editXmlContentField`,
    editDesignTaskFields: (designTaskVersionId, returnContent) =>
        `/api/designTask/version/${designTaskVersionId}/editXmlContentFields${returnContent ? '?returnXmlContent=true' : ''}`,
    getDesignTaskEnumerations: designTaskVersionId => `/api/designTask/version/${designTaskVersionId}/getEnumerations`,
    addBlockToStructure: designTaskVersionId => `/api/designTask/version/${designTaskVersionId}/addBlock`,
    removeBlockOfStructure: designTaskVersionId => `/api/designTask/version/${designTaskVersionId}/removeBlock`,
    changeElementPosition: designTaskVersionId => `/api/designTask/changeElementPosition/${designTaskVersionId}`,
    getDesignTaskChoices: designTaskVersionId => `/api/designTask/version/${designTaskVersionId}/getChoices`,
    addChoice: designTaskVersionId => `/api/designTask/version/${designTaskVersionId}/addChoice`,
    validateVersion: designTaskVersionId => `/api/designTask/version/${designTaskVersionId}/validate`,
    xlsxValidationErrors: designTaskVersionId => `/api/designTask/version/${designTaskVersionId}/xlsxValidationErrors`,
    downloadXML: designTaskVersion => `/api/designTask/xml/${designTaskVersion}`,
    createDesignTask: () => '/api/designTask/create',
    getActiveXsdSchema: () => '/api/designTask/xsdSchema/active',
    getUserByEmail: () => '/api/users/personByEmail',
    mergeDesignTaskCells: designTaskVersionId => ` /api/designTask/version/${designTaskVersionId}/mergeCells`,
    splitDesignTaskCells: designTaskVersionId => `/api/designTask/version/${designTaskVersionId}/splitCells`,
    getDesignTaskCellIndex: (designTaskVersionId, targetPath, rowOrder, cellOrder) =>
        `/api/designTask/version/${designTaskVersionId}/getCellIndex?targetPath=${targetPath}&rowOrder=${rowOrder}&cellOrder=${cellOrder}`,
    addDesignTaskColumn: designTaskVersionId => `/api/designTask/version/${designTaskVersionId}/addColumn`,
    addDesignTaskRow: designTaskVersionId => `/api/designTask/version/${designTaskVersionId}/addRow`,
    removeDesignTaskColumn: designTaskVersionId => `/api/designTask/version/${designTaskVersionId}/removeColumn`,
    removeDesignTaskRow: designTaskVersionId => `/api/designTask/version/${designTaskVersionId}/removeRow`,
    editDesignTaskImage: designTaskVersionId => `/api/designTask/version/${designTaskVersionId}/editImage`,

    checkOks: () => `/api/isup/check-oks`,

    startIsupImport: (requestId) => `/api/isup/${requestId}/request-document-import`,
    cancelIsupImport: (requestId) => `/api/isup/${requestId}/request-document-import-cancel`,
    progressIsupImport: (requestId) => `/api/isup/${requestId}/import-progress`,
    exportIsupImportErrors: (requestId) => `/api/isup/${requestId}/export-errors`,
    getDataOrganizationByUserOrganizationId: (id) => `/api/userorganizations/${id}`,
    getBranchesByUserOrganizationId: (id) => `/api/userorganizations/${id}/branchesWithCount`,
    newCommentRequest: requestId => `api/request/${requestId}/comment`,
    getSupervisionsByUserOrganizationId: (id) => `/api/userorganizations/${id}/supervisions`,
    createSubstitutionToRequest: `/api/substitution/create`,
    createSubstitutionToOrganization: `/api/substitution/createForOrganization`,
    activateSubstitution: (delegationId) =>  `/api/substitution/activate/${delegationId}`,
    getSubstitutionData: (delegationId) =>  `/api/substitution/find/${delegationId}`,
    getSubstitutionDataAttorney: (delegationId) =>  `/api/substitution/findSubstitutionAttorney/${delegationId}`,
    getSubstitutionsForRequest: (requestId) => `/api/substitution/request/${requestId}`,
    copySubstitution: (delegationId) => `/api/substitution/${delegationId}/copy`,
    copySubstitutionOrg: (delegationId) => `/api/substitution/${delegationId}/copyByOrganization`,
    cleanUpSubstitution: (delegationId) => `/api/substitution/cleanUp/${delegationId}`,
    deleteExclusion: (id) => `/api/requestexclusion/${id}`,
    exclusionList: `/api/requestexclusion/list`,
    exclusionAddUsers: (search) => `/api/requestexclusion/users?search=${encodeURIComponent(search)}`,
    exclusionAddRequests: (search) => `/api/requestexclusion/examinationrequests?search=${encodeURIComponent(search)}`,
    exclusionCreate: `/api/requestexclusion/create`,
    getActiveMessage: () => '/api/notification/queue/getCurrentForUser',
    readMessage: (messageId) => `/api/notification/queue/readNotification/${messageId}`,
    
    epGoToXmlgen: '/api/entry/xmlgen',
};

export {apiRoute}



// WEBPACK FOOTER //
// client/config/apiRoutes.es6